@if (training == null || user == null || labels == null || test == null) {
  <app-user-spinner></app-user-spinner>
}
<div class="container d-none d-sm-flex">
  <div class = "row" style = "width: 100%; margin: auto; margin-top: 0px;"    >
    <div class="col-xl-6 col-sm-11 container2">
      <div class="testHeader font">
        <div class = "testQuestion">
          {{test.name}}
          @if (test.durationTime != null) {
            <cd-timer format="user" [countdown]="true" [startTime]="currentTime" (onTick)=onTick() (onComplete)="onTimeIsUp()" #basicTimer style="float: right; color: rgb(241,106,100);">[minutes] : [seconds] </cd-timer>
          }
        </div>
      </div>
      <div style = "display: inline-box !important; margin-top: 3%;">
        <div style = "font-size: 15px;" class="testQuestion font">
          <h5 class = "font" style = "font-size: 15px; margin-bottom: 7%;">{{labels.lblQuestionCapsLock}} {{test.questions[index].order}} {{labels.lblOfCL}} {{test.questions.length}}</h5>
          <h3 class="questionText font" style="line-height: 40px;">
            <span class="bolded-question-text" [innerHTML]="test.questions[index].text"></span>
            @if (showVideoHintIcon && test.questions[index].videoHintPath) {
              <button (click)="openVideoHintComponent()" class="help-btn" mat-raised-button [class]="buttons">{{labels.lblHelp}} <mat-icon>lightbulb</mat-icon></button>
            }
          </h3>
          @if (test.questions[index].imagePath) {
            <div style="text-align: center; background: transparent; width: 90%; margin: auto;">
              <img style="width:100%; height: 100%; margin: auto; object-fit: contain;" src = {{test.questions[index].imagePath}} alt = "test question image">
            </div>
          }
          <div style="font-size: 15px; color: white; margin-bottom: 20px;">
            {{labels.lblQuestionPoints}}
            {{test.questions[index].points}}
            {{labels.lblPointsWithA}}
          </div>
          @if (test.questions[index].type==2) {
            <h4><span style="color:rgb(241,106,100);">*{{labels.lblSeveralCorrectAnswers}}</span></h4>
          }
          @for (answer of test.questions[index].answers; track answer) {
            <div class="answer" [class.answerSelectedEMS]='answer.selected && (user.companyId == 1)' [class.answerSelectedECG]='answer.selected && (user.companyId != 1)'>
              <!-- <input type="checkbox" id="{{answer.id}}" [(ngModel)]="answer.selected" (change)="onSelect(test.questions[index], answer);"/> {{answer.text}} -->
              <mat-checkbox class="checkBox mat-checkbox-stretch" [(ngModel)]="answer.selected" (change)="onSelect(test.questions[index], answer);">
                <div style="width: 100%; font-size: 18px; line-height: 120%; padding: 10px; font-weight: bold; white-space: break-spaces; letter-spacing: 1px;">{{answer.text}}</div>
              </mat-checkbox>
            </div>
          }
        </div>
      </div>
    </div>
    <div class = "col-xl-7 col-sm-3" style = "position: relative;  height: 80px; margin: auto;">
      <div class="buttons" style = "position: absolute; right: 7%; bottom: 10px;">
        <!-- <button mat-raised-button class="button" [class] = "buttons" style="float: left;" *ngIf="!(index==0)"
        (click)="previousQuestion(test.questions[index].order)">
        {{labels.lblBack}}
      </button> -->
      @if ((!(index==test.questions.length-1) && (showNextBtn == true))) {
        <button mat-raised-button class="button"
                (click)="nextQuestion(test.questions[index].order)">
          {{labels.lblSubmit}} <mat-icon style = "vertical-align: middle; margin-left: 15px; color: #0E0D35;">arrow_forward</mat-icon>
        </button>
        <!--<mat-icon style = "cursor: pointer; color: white" (click)="nextQuestion(test.questions[index].order)">arrow_forward_ios</mat-icon>-->
      }
      @if ((!(index==test.questions.length-1) && (showNextBtn == false))) {
        <mat-icon class = "btnDisabled">arrow_forward_ios</mat-icon>
      }

      @if ((index==test.questions.length-1 && (showNextBtn == true))) {
        <button mat-raised-button class="button"
          (click)="submit(test.questions[index].order, false)">
          {{labels.lblSubmit}} <mat-icon style = "vertical-align: middle; margin-left: 15px; color: #0E0D35;">arrow_forward</mat-icon>
        </button>
      }
    </div>
  </div>
  <div class = "row">
    <div class="col-12 progress" style = "left: 0" [style.width]="testProgress+'%'"></div>
  </div>
</div>
</div>

<!-- mobile -->
<div class="mobileContainer row">
  <div class="container2 col-xs-12">
    <div class="testHeader font">
      <div class = "row" style="margin-bottom: 7%; color: white;font-family: Lato, 'Alegreya Sans';">
        {{test.name}}
      </div>
      <div class = "row">
        @if (test.durationTime != null) {
          <!--<cd-timer format="user" [countdown]="true" [startTime]="currentTime" (onTick)=onTick() (onComplete)="onTimeIsUp()" #basicTimer style="float: right; color: rgb(241,106,100); margin: auto;">[minutes] : [seconds] </cd-timer>-->
        }
      </div>
    </div>
    <div class="testQuestion">
      <h5 class = "font" style = "font-size: 15px;">{{labels.lblQuestionCapsLock}} {{test.questions[index].order}} {{labels.lblOfCL}} {{test.questions.length}}</h5>
      <h3 class="questionText">
        <span style="line-height: 35px;" [innerHTML]="test.questions[index].text"></span>
      </h3>
      @if (test.questions[index].imagePath) {
        <div style="width: 90%; margin: 30px auto; text-align: center; background: black;">
          <img style="width:100%; height: 100%; margin: auto; object-fit: contain;" src = {{test.questions[index].imagePath}} alt = "test question image">
        </div>
      }
      @if (test.questions[index].type==2) {
        <h4><span style="color:rgb(241,106,100);">*{{labels.lblSeveralCorrectAnswers}}</span></h4>
      }
      @for (answer of test.questions[index].answers; track answer) {
        <div class="answer" [class.answerSelectedEMS]='answer.selected && (user.companyId == 1)' [class.answerSelectedECG]='answer.selected && (user.companyId != 1)'>
          <!-- <input type="checkbox" id="{{answer.id}}" [(ngModel)]="answer.selected" (change)="onSelect(test.questions[index], answer);"/> {{answer.text}} -->
          <mat-checkbox class="checkBox " [(ngModel)]="answer.selected" (change)="onSelect(test.questions[index], answer);">
            <span style="font-size: 2vh; font-weight: bold; white-space: pre-line;">{{answer.text}}</span>
          </mat-checkbox>
        </div>
      }
    </div>
    <div class="buttons" style = "margin-right: 15px; text-align: right;">
      <!-- <button mat-raised-button class="button" [class] = "buttons" style="float: left;" *ngIf="!(index==0)"
      (click)="previousQuestion(test.questions[index].order)">
      {{labels.lblBack}}
    </button> -->
    @if ((!(index==test.questions.length-1) && (showNextBtn == true))) {
      <button mat-raised-button class="button"
              (click)="nextQuestion(test.questions[index].order)">
        {{labels.lblSubmit}} <mat-icon style = "vertical-align: middle; margin-left: 15px; color: #0E0D35;">arrow_forward</mat-icon>
      </button>
      <!--<mat-icon style = "cursor: pointer; color: white" (click)="nextQuestion(test.questions[index].order)">arrow_forward_ios</mat-icon>-->
    }
    @if ((!(index==test.questions.length-1) && (showNextBtn == false))) {
      <mat-icon class = "btnDisabled">arrow_forward_ios</mat-icon>
    }

    @if ((index==test.questions.length-1 && (showNextBtn == true))) {
      <button mat-raised-button class="button"
        (click)="submit(test.questions[index].order, false)">
        {{labels.lblSubmit}} <mat-icon style = "vertical-align: middle; margin-left: 15px; color: #0E0D35;">arrow_forward</mat-icon>
      </button>
    }
  </div>
</div>
<div class = "col-12" class="progress" [style.width]="testProgress+'%'"></div>
</div>
